// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1JA5Y","item":"PaymentsMobile_item__165Bk","label":"PaymentsMobile_label__3afGK","amount":"PaymentsMobile_amount__1Xzzw"};